import { hasConsentGroup } from '../../utils';

export const hasGoogleMapsConsent = (groups?: string | string[]) => hasConsentGroup({ group: 'C0003', groups });
